const DEFAULT_TTL_MS = 5 * 60 * 1000;
const DEFAULT_MAX_ENTRIES = 2000;

const deliveredMessages = new Map();

const toStringOrNull = (value) => {
  if (value == null) return null;
  const normalized = String(value).trim();
  return normalized || null;
};

const resolveStableMessageKey = (scope, payload = {}) => {
  if (!payload || typeof payload !== 'object') return null;
  const serverMsgId = toStringOrNull(
    payload.server_msg_id ??
      payload.serverMsgId ??
      payload.message_id ??
      payload.messageId ??
      null,
  );
  const eventId = toStringOrNull(payload.event_id ?? payload.eventId ?? null);
  const stableId = serverMsgId || eventId;
  if (!stableId) return null;

  const conversationId = toStringOrNull(
    payload.conversation_id ?? payload.conversationId ?? null,
  );
  const groupId = toStringOrNull(payload.group_id ?? payload.groupId ?? null);
  return [scope, conversationId || groupId || 'global', stableId].join(':');
};

const pruneDeliveredMessages = ({ now, ttlMs, maxEntries }) => {
  deliveredMessages.forEach((receivedAt, key) => {
    if (now - receivedAt > ttlMs) deliveredMessages.delete(key);
  });
  while (deliveredMessages.size > maxEntries) {
    const oldestKey = deliveredMessages.keys().next().value;
    if (oldestKey == null) break;
    deliveredMessages.delete(oldestKey);
  }
};

export const shouldDeliverCableMessage = (
  scope,
  payload,
  {
    now = Date.now(),
    ttlMs = DEFAULT_TTL_MS,
    maxEntries = DEFAULT_MAX_ENTRIES,
  } = {},
) => {
  const key = resolveStableMessageKey(scope, payload);
  if (!key) return true;

  pruneDeliveredMessages({ now, ttlMs, maxEntries });
  const previousReceivedAt = deliveredMessages.get(key);
  if (previousReceivedAt != null && now - previousReceivedAt <= ttlMs) {
    return false;
  }
  deliveredMessages.delete(key);
  deliveredMessages.set(key, now);
  pruneDeliveredMessages({ now, ttlMs, maxEntries });
  return true;
};

export const resetCableMessageDeduperForTests = () => {
  deliveredMessages.clear();
};
